import { queryOptions, useQuery } from '@tanstack/react-query';

import { ApiResponse, QueryOptions } from '@cast/shared-types';
import { makeIsEnabled } from '@cast/utils';

import { apiClient } from '@cast/infrastructure-api';

const apiFn = apiClient.dbo.getProxyCacheSummary;

export type DatabaseProxyCacheSummaryQueryData = ApiResponse<typeof apiFn>;

const DBO_DATABASE_PROXY_CACHE_SUMMARY_QUERY_KEY =
  'dbo-database-proxy-cache-summary';

const getDatabaseProxyCacheSummaryQueryKey = (
  params: Parameters<typeof apiFn>[0]
) => [DBO_DATABASE_PROXY_CACHE_SUMMARY_QUERY_KEY, params] as const;

export const useDatabaseProxyCacheSummaryQuery = <
  Select = DatabaseProxyCacheSummaryQueryData
>(
  params: Parameters<typeof apiFn>[0],
  options?: QueryOptions<DatabaseProxyCacheSummaryQueryData, Select>
) =>
  useQuery(
    queryOptions({
      queryKey: getDatabaseProxyCacheSummaryQueryKey(params),
      queryFn: async () => {
        const { data } = await apiFn(params);
        return data;
      },
      enabled: makeIsEnabled(
        !!params.organizationId,
        !!params.proxyId,
        !!params.databaseName,
        options?.enabled ?? true
      ),
      ...options,
    })
  );
